/**
 * @param value String to test if landline
 * @returns boolean True if value matches landline pattern
 */
const isLandLine = (value: string): boolean => {
    return /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/.test(value);
};

export default isLandLine;
